    // Function to inject a div element with a scroll top link  
    function injectDiv() {  
        // Create the HTML string for the new div  
        const htmlString = '<div class="scrolltop"><a href="#shopify-section-header"> <img src="/cdn/shop/t/30/assets/products_slider_arrow_right_1.svg?v=149991943519480495841716637601"> </a></div>';  
        
        // Inject the HTML string at the end of the body  
        document.body.insertAdjacentHTML('beforeend', htmlString);  

        // Get the scroll top element  
        const scrollTopElement = document.querySelector('.scrolltop');  

        // Show the scroll top button when scrolling down  
        window.onscroll = function() {  
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {  
                scrollTopElement.style.display = "block";  
            } else {  
                scrollTopElement.style.display = "none";  
            }  
        };  

        // Add click event to the scroll top link  
        scrollTopElement.addEventListener('click', function(event) {  
            event.preventDefault(); // Prevent default anchor behavior  
            smoothScrollToTop();  
        });  
    }  

    // Function to smoothly scroll to the top  
    function smoothScrollToTop() {  
        const scrollDuration = 500; // Duration of the scroll in milliseconds  
        const scrollStep = -window.scrollY / (scrollDuration / 15); // Calculate scroll step  
        const scrollInterval = setInterval(() => {  
            if (window.scrollY !== 0) {  
                window.scrollBy(0, scrollStep); // Scroll by the calculated step  
            } else {  
                clearInterval(scrollInterval); // Clear the interval when done  
            }  
        }, 15);  
    }  

    // Add an event listener for the window load event  
    window.onload = injectDiv;  